import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    //テキスト
      textField: {
        flexGrow: 1,
        height: '100%',
        width: '98%',
        border: 'none',
        backgroundColor: 'transparent',
        textAlign: "center",
    },
  })
);

export const StorageCapacitySettingStyle = makeStyles(
  createStyles({
     tableContainer: {
      maxHeight: 'calc(100vh - 386px)',
    },
     paperRoot: {
      maxWidth: '700px',
      minWidth: '400px',
      padding: '5px',
    },
  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
